<template>
  <score-overview :type="scoreType" />
</template>

<script lang="ts">
import ScoreOverview from './ScoreOverview.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  data () {
    return {
      scoreType: 'digital_footprint',
    }
  },
  components: {
    ScoreOverview
  }
})
</script>
